/* el-results.js — sections/el-results.liquid
   Hair / Skin tabs (click and arrow keys) and the mobile progress line. */
(function () {
  'use strict';

  function select(section, tab, focus) {
    section.querySelectorAll('[data-el-results-tab]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    section.querySelectorAll('[data-el-results-panel]').forEach(function (p) {
      p.hidden = p.dataset.elResultsPanel !== tab.dataset.elResultsTab;
    });
    if (focus) tab.focus();
    progress(section);
  }

  function progress(section) {
    section.querySelectorAll('[data-el-results-panel]:not([hidden])').forEach(function (panel) {
      var track = panel.querySelector('[data-el-results-track]');
      var thumb = panel.querySelector('[data-el-results-thumb]');
      if (!track || !thumb) return;
      var max = track.scrollWidth - track.clientWidth;
      thumb.style.setProperty('--el-rs-progress', max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 0);
    });
  }

  /* Mouse drag for rows that scroll sideways (touch and trackpads already swipe natively).
     Snapping is paused while dragging, then the row settles on the nearest card. */
  function drag(track) {
    var startX = 0, startLeft = 0, active = false, moved = false;
    track.addEventListener('dragstart', function (event) { event.preventDefault(); });
    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || track.scrollWidth <= track.clientWidth) return;
      active = true; moved = false;
      startX = event.clientX; startLeft = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (event) {
      if (!active) return;
      var dx = event.clientX - startX;
      if (!moved && Math.abs(dx) < 4) return;
      if (!moved) {
        moved = true;
        track.setPointerCapture(event.pointerId);
        track.style.scrollSnapType = 'none';
        track.classList.add('is-dragging');
      }
      track.scrollLeft = startLeft - dx;
    });
    function end(event) {
      if (!active) return;
      active = false;
      if (!moved) return;
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      track.classList.remove('is-dragging');
      /* settle on the nearest card, then hand back to CSS snapping */
      var cards = Array.prototype.slice.call(track.children);
      var origin = track.getBoundingClientRect().left;
      var best = cards.reduce(function (b, c) {
        var d = Math.abs(c.getBoundingClientRect().left - origin);
        return d < b.d ? { c: c, d: d } : b;
      }, { c: null, d: Infinity });
      var target = best.c ? track.scrollLeft + best.c.getBoundingClientRect().left - origin : track.scrollLeft;
      track.scrollTo({ left: target, behavior: 'smooth' });
      setTimeout(function () { track.style.scrollSnapType = ''; }, 400);
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-el-results]').forEach(function (section) {
      if (section.dataset.elReady) return;
      section.dataset.elReady = '1';
      section.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-el-results-tab]');
        if (tab) select(section, tab, false);
      });
      section.addEventListener('keydown', function (event) {
        var tab = event.target.closest('[data-el-results-tab]');
        if (!tab || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
        var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-el-results-tab]'));
        var next = tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        event.preventDefault();
        select(section, next, true);
      });
      section.querySelectorAll('[data-el-results-track]').forEach(function (track) {
        track.addEventListener('scroll', function () { progress(section); }, { passive: true });
        drag(track);
      });
      window.addEventListener('resize', function () { progress(section); });
      /* Photos-only mobile slider: start with the second card centred, as designed */
      if (section.classList.contains('el-results--mobile-cards') && window.matchMedia('(max-width: 1023px)').matches) {
        var track = section.querySelector('[data-el-results-panel]:not([hidden]) [data-el-results-track]');
        var cards = track ? track.children : [];
        if (cards.length > 2) {
          var cardBox = cards[1].getBoundingClientRect();
          var trackBox = track.getBoundingClientRect();
          track.scrollLeft += (cardBox.left + cardBox.width / 2) - (trackBox.left + trackBox.width / 2);
        }
      }
      progress(section);
    });
  }

  init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    /* show the tab of the block being edited */
    var section = event.target.closest('[data-el-results]');
    var panel = event.target.closest('[data-el-results-panel]');
    if (!section || !panel) return;
    var tab = section.querySelector('[data-el-results-tab="' + panel.dataset.elResultsPanel + '"]');
    if (tab) select(section, tab, false);
  });
})();
